import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig } from '@angular/platform-browser';
import {ErrorHandler, Inject, LOCALE_ID, NgModule} from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import {
    NbThemeModule,
    NbLayoutModule,
    NbToastrModule,
    NbIconModule,
    NbMenuModule,
    NbMenuService,
    NbDialogModule,
    NbDatepickerModule,
    NbButtonModule,
    NbButtonGroupModule,
    NbOptionModule,
    NbSelectModule
} from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import {Store, StoreModule} from '@ngrx/store';
import { authReducer } from './shared/store/user/auth.reducer';
import { EffectsModule } from '@ngrx/effects';
import { AuthEffects } from './shared/store/user/auth.effect';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { JwtInterceptor } from './shared/interceptors/jwt-interceptor';
import { CityEffects } from './shared/store/city/city.effect';
import { citiesReducer } from './shared/store/city/city.reducer';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ErrorHandlerInterceptor } from './shared/interceptors/error-handler-interceptor';
import { NbMomentDateModule } from '@nebular/moment';
import {NgCircleProgressModule} from 'ng-circle-progress';
import { DragulaModule } from 'ng2-dragula';
import {VideoRecordingService} from './pv-modules/pv-recruitment/process-steps/recruitement-interview-step/video-recording.service';
import { UntypedFormBuilder } from '@angular/forms';
import {SharedModule} from './shared/shared.module';
import {CommonAutocompleteModule} from './common-modules/common-autocomplete/common-autocomplete.module';
import {CommonCardModule} from './common-modules/common-card/common-card.module';
import {EditorModule} from '@tinymce/tinymce-angular';
import {PvRecruitmentModule} from './pv-modules/pv-recruitment/pv-recruitment.module';
import {environment} from '../environments/environment';
import {GlobalErrorHandler} from './shared/services/global-error-handler.service';
import {ApiErrorService} from "./shared/services/apiError.service";
import { CommonTranslateModule } from './common-modules/common-translate/common-translate.module';
import { APP_INITIALIZER } from '@angular/core';

registerLocaleData(localeFr, 'fr');

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent],
    imports: [
        SharedModule,
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        CommonAutocompleteModule,
        NbThemeModule.forRoot({ name: 'default' }),
        StoreModule.forRoot({
            user: authReducer,
            cities: citiesReducer
        }),
        StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: environment.production,
        }),
        EffectsModule.forRoot([
            AuthEffects,
            CityEffects
        ]),
        NbLayoutModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        NbToastrModule.forRoot(),
        // NbOverlayModule.forRoot(),
        NbEvaIconsModule,
        NbMenuModule.forRoot(),
        NbDialogModule.forRoot(),
        NbDatepickerModule.forRoot(),
        NbMomentDateModule,
        NgCircleProgressModule.forRoot(),
        DragulaModule.forRoot(),
        EditorModule,
        NbButtonModule,
        NbIconModule,
        NbSelectModule,
        NbOptionModule,
        CommonCardModule,
        NbButtonGroupModule,
        PvRecruitmentModule,
        CommonTranslateModule
    ],
    providers: [
        NbMenuService,
        VideoRecordingService,
        UntypedFormBuilder,
        /*  {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: MyHammerConfig
          },*/
        { provide: LOCALE_ID, useValue: 'fr' },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorHandlerInterceptor, multi: true },
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => {
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&libraries=places&language=fr`;
            document.head.appendChild(script);
            },
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
}
